package com.sddamico.components.motion

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.active
import org.jetbrains.compose.web.css.ms

/** Transition for anything that also uses [PressableStyle], so the press keeps animating alongside colour changes. */
val PressTransition: Transition.Listable = Transition.of("transform", Durations.PRESS.ms, Ease.Out.fn)

/**
 * A slight squeeze while a button is held down, so a tap registers before whatever it triggers has responded.
 * Elements with their own inline `transition` must include [PressTransition] in it.
 */
val PressableStyle = CssStyle {
    base { Modifier.transition(PressTransition) }
    active { Modifier.scale(0.97) }
    cssRule(ReducedMotionQuery, ":active") { Modifier.scale(1) }
}
